import * as types from './types';

const initialState = {
  userData: null,
  loading: false,
  fetched: false,
  success: false,
  fetchUserDataError: false,
  updateUserDataError: false
};

function userDataReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_DATA:
      return {
        ...state,
        loading: true
      };

    case types.GET_USER_DATA_COMPLETED:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        fetched: true
      };

    case types.GET_USER_DATA_FAILED:
      return {
        ...state,
        loading: false,
        fetched: true,
        fetchUserDataError: true
      };

    case types.UPDATE_USER_DATA:
      return {
        ...state,
        loading: true
      };

    case types.UPDATE_USER_DATA_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true,
        fetchUserDataError: false
      };

    case types.UPDATE_USER_DATA_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        updateUserDataError: true
      };

    case types.RESET_USER_DATA:
      return {
        ...state,
        success: false,
        fetchUserDataError: false,
        updateUserDataError: false,
        userData: null
      };

    case types.RESET_FETCH:
      return {
        ...state,
        success: false,
        fetchUserDataError: false,
        updateUserDataError: false
      };

    default:
      return state;
  }
}

export default userDataReducer;
